<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} ContactType` }}
            </h4>
            <v-form ref="contactTypeForm" @submit.prevent="save()">
              <v-row>
                <v-col md="12">
                  <v-text-field
                    v-model="contactTypeModel.name"
                    label="ContactType Name"
                    required
                    outlined
                    :rules="[(v) => !!v || 'ContactType Name is required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { ContactType } from "@/models/ContactType";
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      contactTypeModel: new ContactType(),
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "ContactTypes",
          disabled: false,
          href: "/admin/contactTypes",
        },
        {
          text: "ContactType Detail",
          disabled: false,
          href: `/admin/contactType/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} ContactType`,
          disabled: true,
        },
      ];
    },
  },
  watch: {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    contactType: {
      query: gql`
        query ContactType($id: ID!) {
          contactType(id: $id) {
            id
            name
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.contactTypeModel.id = this.contactType.id;
        this.contactTypeModel.name = this.contactType.name;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.contactTypeForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateContactType()
          .then(() => {
            this.$swal("Success!", "ContactType was updated", "success");
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "something went wrong when trying to update the contactType, check data and try again later!",
              "error"
            );
          });
      } else {
        // create
        await this.createContactType()
          .then(() => {
            this.$swal("Success!", "ContactType was created", "success");
            window.location.href = `/admin/contactType/${self.contactTypeModel.id}/edit`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `Something went wrong when creating the contactType, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateContactType() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($contactType: ContactTypeUpdateInput!) {
              updateContactType(contactType: $contactType) {
                id
                updated
              }
            }
          `,
          variables: {
            contactType: {
              id: self.contactTypeModel.id,
              name: self.contactTypeModel.name,
              createdBy: self.me.id,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the contactType!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createContactType() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createContactType($contactType: ContactTypeCreateInput!) {
              createContactType(contactType: $contactType) {
                id
              }
            }
          `,
          variables: {
            contactType: {
              name: self.contactTypeModel.name,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the ContactType Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createContactType) {
          self.contactTypeModel.id = response?.data?.createContactType?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
